export function parseAppDate(value) {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const raw = String(value).trim();
  if (!raw || raw === '0000-00-00 00:00:00') return null;

  const normalized = raw.includes('T') ? raw : raw.replace(' ', 'T');
  const date = new Date(normalized);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

export function formatAppDate(value, options = {}) {
  const date = parseAppDate(value);
  if (!date) return '';
  return date.toLocaleString('vi-VN', options);
}

export function formatAppDateOnly(value, options = {}) {
  const date = parseAppDate(value);
  if (!date) return '';
  return date.toLocaleDateString('vi-VN', options);
}

export function formatMonthValue(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
}
